var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"global-dialog",attrs:{"append-to-body":true,"visible":_vm.dialogVisible,"title":"选择品种规格","width":"1200px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('GrainSpecifications',{attrs:{"isBulkOil":_vm.isBulkOil,"is-choose":""},on:{"select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }